import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash-circle",
  "use": "trash-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"trash-circle\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FB6992\" stroke-width=\".5\"><circle cx=\"8\" cy=\"8\" r=\"7.75\" fill=\"#FFF\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 5.6h8m-.889 0v5.6c0 .442-.398.8-.889.8H5.778c-.491 0-.89-.358-.89-.8V5.6m1.334 0v-.8c0-.442.398-.8.89-.8h1.777c.49 0 .889.358.889.8v.8m-2.667 2V10m1.778-2.4V10\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol